import flashMessageMixin from '../../mixins/_flash_messages';
import progressBar from '../../components/_progress_bar';
import userProgressMixin from '../../mixins/_user_progress';
import tasks from './_tasks';

/**
 * 各ページ共通mixin
 */
export default {
    data () {
        return {
            // タスク情報データ
            tasks: {},
        };
    },
    components: {
        // タスク一覧コンポーネント
        'tasks': tasks,
        // プログレスバーコンポーネント
        'progress-bar': progressBar,
    },
    mixins: [
        flashMessageMixin,
        userProgressMixin,
    ],
    methods: {
        // 完了
        async done (event) {
            const paths = location.pathname.split('/');
            const category = paths[2];
            const task = paths[3];
            if (await this.updateUserProgress(category, task)) {
                this.$_loading();
                window.location.href = event.target.href;
            }
        }
    }
};
